import { DagView } from '@frontend/wam-sales-demo-service';
import { Page } from '../../components/page-layout/page';
import { createFileRoute } from '../../utils/route-factory';

function SalesDemoDag() {
  return (
    <Page
      title='Sales Demo - DAG'
      breadcrumbs={[{ label: 'Global Settings' }, { label: 'Sales Demo' }, { label: 'DAG' }]}
      maxWidth='100%'
    >
      <div
        style={{
          padding: '16px',
          backgroundColor: 'white',
          borderRadius: '8px',
          border: '1px solid #e0e0e0',
          height: 'calc(100vh - 220px)',
          minHeight: '400px',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <DagView />
      </div>
    </Page>
  );
}

export const Route = createFileRoute({
  path: '/global-settings/sales-demo-dag',
  component: SalesDemoDag,
  type: 'auth',
  locationRequired: false,
});
